const ossApi = '/ossApi'
let hostname = window.location.hostname

let tenantCode = ''
let title = ''
let imageUrl = ''
let username = ''
let password = ''
let serviceUrl = ''  //履职服务平台
console.log(hostname)
if (hostname === 'www.yjxrd.gov.cn' || hostname === 'yjxrd.gov.cn') {
  tenantCode = '410726000000000001'
  title = '延津县'
  imageUrl = ossApi + '/410726'
  username = 'yjxwzgly'
  password = 'Aa123456'
  serviceUrl = 'http://39.98.66.183:9000/yjrd'
} else if (hostname === 'www.yuanyangrd.gov.cn' || hostname === 'yuanyangrd.gov.cn') {
  tenantCode = '410725000000000001'
  title = '原阳县'
  imageUrl = ossApi + '/410725'
  username = 'yyxwzgly'
  password = 'Aa123456'
  serviceUrl = 'http://39.98.66.183:9000/yyxrd'
} else if (hostname === 'www.fengqiurenda.gov.cn' || hostname === 'fengqiurenda.gov.cn') {
  tenantCode = '410727000000000001'
  title = '封丘县'
  imageUrl = ossApi + '/410727'
  username = 'fqxwzgly'
  password = 'Aa123456'
  serviceUrl = 'http://39.98.66.183:9000/fqxrd'
}



switch (process.env.NODE_ENV) {
  case 'development': // 开发环境
    tenantCode = '410726000000000001'
    title = '延津县'
    imageUrl = ossApi + '/410726'
    username = 'yjxwzgly'
    password = 'Aa123456'
    serviceUrl = 'http://39.98.66.183:9000/yjrd'
    break
  default:
    break
}
export default {
  ossApi,
  tenantCode,
  title,
  imageUrl,
  username,
  password,
  serviceUrl
}
